import apiClient from "./client";

export default {
  getAll: () => apiClient.get("/email-templates").then((res) => res.data),

  getByType: (templateType) =>
    apiClient.get(`/email-templates/type/${templateType}`).then((res) => res.data),

  getById: (id) =>
    apiClient.get(`/email-templates/${id}`).then((res) => res.data),

  create: (data) =>
    apiClient.post("/email-templates", data).then((res) => res.data),

  update: (id, data) =>
    apiClient.put(`/email-templates/${id}`, data),

  delete: (id) =>
    apiClient.delete(`/email-templates/${id}`),

  /** Duplicate an existing template; returns the new {templateId, name, …}. */
  duplicate: (id) =>
    apiClient.post(`/email-templates/${id}/duplicate`).then((res) => res.data),

  /** Returns { TemplateType: { wired: bool, firedBy: string, source: string } } */
  getUsage: () =>
    apiClient.get(`/email-templates/usage`).then((res) => res.data),

  render: (templateType, placeholders) =>
    apiClient.post("/email-templates/render", {
      templateType,
      placeholders,
    }).then((res) => res.data),

  /** Returns { templateType, fields:[], helpers:[] } for the chip palette + autocomplete. */
  getTokens: (templateType) =>
    apiClient.get(`/email-templates/tokens/${templateType}`).then((res) => res.data),

  /** Render unsaved draft content. Body: { templateType, content, placeholders? } */
  renderPreview: (payload) =>
    apiClient.post("/email-templates/preview", payload).then((res) => res.data),

  /** Send a test email to the logged-in user. Body: { templateType, subject, content, placeholders?, recipientEmail? } */
  testSend: (payload) =>
    apiClient.post("/email-templates/test-send", payload).then((res) => res.data),
};





